<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'信息漏斗'},{title:'客户年度目标'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                  <el-form-item class="h-elformWrap-1" label="客户名称">
                    <el-input v-model="q.username" placeholder="请输入客户编码或名称" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="区域" prop="area">
                    <el-select v-model="q.area" clearable placeholder="请选择" style="width:100%">
                      <el-option v-for="item in quyuList"
                                 :key="item.code"
                                 :label="item.name"
                                 :value="item.name">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="渠道" prop="channel">
                    <el-select v-model="q.channel" clearable placeholder="请选择" style="width:100%">
                      <el-option v-for="item in qudaoList"
                                 :key="item.code"
                                 :label="item.name"
                                 :value="item.name">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="年度">
                    <el-select filterable v-model="q.year" clearable placeholder="请选择">
                      <el-option
                          v-for="(item) in qyearList"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <!-- 展开搜素 -->
                <div class="l-screenBox">
                    <!-- <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                    </div> -->
                    <div class="l-retrieval">
                    <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                    <!-- <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                        新建目标
                    </el-button> -->
                    </div>
                </div>
            </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!--  -->
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    stripe
                    max-height="560"
                    style="width: 100%" >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                        <el-table-column
                            label="序号"
                            type="index"
                            width="50">
                        </el-table-column>
                    <el-table-column prop="usercode" label="客户编码" width="120" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="username" label="客户名称" width="160" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="area" label="区域" width="70" ></el-table-column>
                    <el-table-column prop="channel" label="渠道" width="70" ></el-table-column>
                    <el-table-column prop="product" label="链群" width="70" ></el-table-column>
                    <el-table-column prop="year" label="年度" width="70"></el-table-column>
                    <el-table-column prop="jan" label="1月" width="70" ></el-table-column>
                    <el-table-column prop="feb" label="2月" width="70"></el-table-column>
                    <el-table-column prop="mar" label="3月" width="70" ></el-table-column>
                    <el-table-column prop="apr" label="4月" width="70" ></el-table-column>
                    <el-table-column prop="may" label="5月" width="70" ></el-table-column>
                    <el-table-column prop="jun" label="6月" width="70" ></el-table-column>
                    <el-table-column prop="jul" label="7月" width="70" ></el-table-column>
                    <el-table-column prop="aug" label="8月" width="70" ></el-table-column>
                    <el-table-column prop="sep" label="9月" width="70" ></el-table-column>
                    <el-table-column prop="oct" label="10月" width="70" ></el-table-column>
                    <el-table-column prop="nov" label="11月" width="70" ></el-table-column>
                    <el-table-column prop="dece" label="12月" width="70" ></el-table-column>

                    <el-table-column prop="cuname" label="创建人" width="100" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="cdate" label="创建时间" width="100" :formatter="formatDate" ></el-table-column>


                    <el-table-column
                        label="操作"
                        fixed="right"
                        width="150"
                    >
                        <template slot-scope="scope">
                            <el-button
                            type="text"
                            size="small"
                            class="h-tableLink h-btn"
                            @click="deleteSelete(scope.row.id)"
                            >删除</el-button>
                            <!-- <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateDetail(scope.row)"
                            >编辑</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <div class="h-tableBL">
                             <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-delete" @click="deleteSeletes">批量删除</el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                        @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="annualTargetExcel"
                                    :startrow="2" @callback="uploadExcelFilecallback"/>
                        </div>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="selectPageAll" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
export default {
    data() {
        return {
            q:{
                username:'',
                usercode:'',
                keyWord:"",
                pageNo:1,
                pageSize:10,
                total:0,
            },
            size:'',
            tableData: [],
            quyuList: [],
            qyearList: [],
            qudaoList:[],
            //表格
            multipleSelection: [],
            // 展开折叠筛选
            isScreen:false,
            uploaddownexcelflag:false,



            newDialog:false,
            editDialog:false,

            yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
            weekList:[],
            add:{
                year:'',
                week:'',
                userList:[0],
                targetContent:'',
                customerName:'',
                visitDateNew:'',
                clearType:''
            },
            edit:{
                id:'',
                deId:'',
                userList:[0],
                targetContent:'',
                customerName:'',
                visitDateNew:'',
                clearType:''
            },
            authTypeListEdit:[],
            disEdit:false,
            workList:[],
            AuthoCheck: '',
            authTypeList: [],
            userList: [0],
            weekPlanList:[],
            groupList: [],
            groupArr:[],
            titleDig:""
        }

    },

    methods: {

        //表格
        handleSelectionChange(val) {
           this.multipleSelection = val;
        },
        deleteSeletes(){
            var list = [];
            this.multipleSelection.forEach(element => {
              list.push(element.id);
            });
            console.log(list)
            this.deleteSingle(list)
        },
        deleteSelete(id){
          var list = [];
          list.push(id),
              this.multipleSelection.forEach(element => {
                list.push(element.id);
              });
          console.log(list)
          this.deleteSingle(list)
        },
        deleteSingle(list){
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    ss.annualTargetApi.deleteAnnualTarget(list).then(res => {
                        console.log("delete",list);
                        if(res.f == true ){
                             this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.selectPageAll()
                        }else{
                            this.$message.error(res.msg);
                        }
                    })

                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        selectPageAll(){
            console.log("12312312312",this.q)
            ss.annualTargetApi.selectPage(this.q).then(res =>
            {
                console.log("res=="+res)
                this.tableData = res.records
                this.q.total = res.total
                //this.listProject = res.msg
            })
        },
        //
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },
        uploadExcelFilecallback(rd) {
            this.query();
            this.$msg.msgs(rd.msg);
            this.selectPageAll()
        },
        formatDate(row, column) {
          // 获取单元格数据
          let data = row[column.property]
          if(data == null || data == '') {
            return null
          }
          let dt = new Date(data)
          return this.$util.riQi3(dt);
        },
        //导出
		exportExcel() {
            updownfile.down("api/swyl/v1/annual/target/downloadExcel",this.q,"post",'data');
        },
        getNowTime() {
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth(); //得到月份
            var date = now.getDate(); //得到日期
            month = month + 1;
            month = month.toString().padStart(2, "0");
            date = date.toString().padStart(2, "0");
            var defaultDate = `${year}-${month}-${date}`;

           // this.$set(this.q, "visitDate", defaultDate);
           // this.$set(this.add, "visitDateNew", defaultDate);
        },

        //新增日清
        create(){
            this.newDialog = true;
            this.titleDig="新建日计划"
        },
        getWeeks(y){
            ss.MuBiao.getWeekList({year:y}).then(rd => {
                this.weekList = rd;
            })
        },
        getWeeksBySelectYear(){
            this.getWeeks(this.add.year);
            ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                this.addlianqunList = rd;
            })
        },
        selectWeek(){
            console.log(this.add.week)
            this.getWeekPlan()
        },
        getqWeeksBySelectYear(){
            this.getqWeeks(this.q.year,1);
        },
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        rest(){
            var pageSize=this.q.pageSize;
            var pageNo=this.q.pageNo;
            var total=this.q.total;
            this.q= {
                pageSize: pageSize,
                pageNo: pageNo,
                total:total,
                visitDate:'',
                username:'',
                usercode:'',
                keyword:'',
            }
        },
        exit(){
            this.newDialog= false,
            this.editDialog = false
        },
        getQuyuList(){
          ss.Dictservice.listbycategory("YLRegion").then(rd=>{
            this.quyuList = rd;
          })
        },
        getQudaoList(){
          ss.Dictservice.listbycategory("sales_region").then(rd=>{
            this.qudaoList = rd;
          })
        },
    },
    watch:{
        'add.customerName': {
            deep: true,
            handler: function (newVal,oldVal){
            this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
            var len = this.groupList.length;//groupList
            var arr = [];
            for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                arr.push({
                    value:this.groupList[i].name,
                    id:this.groupList[i].id
                })
                }
            }
            this.groupArr = arr
            }
        },
    },
    created(){
        this.getNowTime()
        this.selectPageAll()
        this.add.year =  this.yearList[0]
        this.getWeeks(new Date().getFullYear());
        this.getQudaoList()
        this.getQuyuList()
        for(var i =2021;i<new Date() .getFullYear()+2;i++){
          this.qyearList.push(i);
        }
    },
    components: {
        uploaddownexcel,
    },

}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:80px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
</style>
